@if (!fullPageMode) {
  <button #alertTrigger (onMenuOpen)="onMenuOpen()" [disabled]="!hasAlerts" [matMenuTriggerFor]="toolbarAlertMenu"
    [ngClass]="alertTriggerBtn && alertTriggerBtn.menuOpen || !hasAlerts?'':'pulse'" mat-icon-button>
    <mat-icon [style]="hasAlerts?'color:mediumpurple':'color:rgba(0, 0, 0, 0.26);'" fontIcon="fa-house-person-return"
    fontSet="fa-solid" style="font-size:22px;"></mat-icon>
    @if (alertCount>0 && alertCount < 10) {
      <span
      style="color: white; position: absolute; left: 18px; padding-top: 2px; font-size: 14px;">{{ alertCount }}</span>
    }
    @if (alertCount>=10 ) {
      <span style="color: white; position: absolute; left: 17px; font-size: 12px;">{{ alertCount}}</span>
    }
  </button>
  <mat-menu #toolbarAlertMenu="matMenu" class="padded-menu" xPosition="before">
    @if (!alertData) {
      <p>Loading...</p>
    }
    @if (alertData) {
      @for (problemDay of alertData.dates; track problemDay) {
        <div>
          <div class="date-separator">
            {{
            problemDay.date | amCalendar:{
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: 'DD/MM/YYYY'
          }
          }}
          <span class="spacer"></span> {{ problemDay.totalAlerts }} Issue{{ problemDay.totalAlerts > 1 ? 's' : '' }}
        </div>
        @if (problemDay.tickets) {
          @for (ticket of problemDay.tickets; track ticket) {
            <div (click)="openTicketDialog(ticket.ticket.id)" class="alert-menu-widget">
              @if (ticket.ticket) {
                <div>
                  Ticket {{ ticket.ticket.id }} for job {{ ticket.ticket.visit.job.externalJobReference }}<br />
                  Currently assigned to {{ ticket.ticket.resourceAvailability.resource.name }}
                  at {{ ticket.ticket.startedTime | amDateFormat : 'HH:mm' }}
                  <ul>
                    @for (issue of ticket.issues; track issue) {
                      <li>{{ issue }}</li>
                    }
                  </ul>
                </div>
              }
              @if (!ticket.ticket) {
                <div>
                  Loading..
                </div>
              }
            </div>
          }
        }
      </div>
    }
  }
</mat-menu>
}
@if (fullPageMode) {
  @if (!alertData) {
    <p>All clear!</p>
  }
  @if (alertData) {
    @for (problemDay of alertData.dates; track problemDay) {
      <div>
        <div class="date-separator">
          {{
          problemDay.date | amCalendar:{
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: '[Last] dddd',
          sameElse: 'DD/MM/YYYY'
        }
        }}
        <span class="spacer"></span> {{ problemDay.totalAlerts }} Issue{{ problemDay.totalAlerts > 1 ? 's' : '' }}
      </div>
      @if (problemDay.tickets) {
        @for (ticket of problemDay.tickets; track ticket) {
          <div (click)="openTicketDialog(ticket.ticket.id)" class="alert-menu-widget">
            @if (ticket.ticket) {
              <div>
                Ticket {{ ticket.ticket.id }} for job {{ ticket.ticket.visit.job.externalJobReference }}<br />
                Currently assigned to {{ ticket.ticket.resourceAvailability.resource.name }}
                at {{ ticket.ticket.startedTime | amDateFormat : 'HH:mm' }}
                <ul>
                  @for (issue of ticket.issues; track issue) {
                    <li>{{ issue }}</li>
                  }
                </ul>
              </div>
            }
            @if (!ticket.ticket) {
              <div>
                Loading...
              </div>
            }
          </div>
        }
      }
    </div>
  }
}
}
